<template>
  <v-navigation-drawer v-model="opened" fixed>
    <template #prepend>
      <div class="pa-3 d-flex align-center justify-space-between">
        <span
          class="highlighted-text display-1 font-weight-black px-3 rounded"
          style="font-family: 'Roboto', sans-serif !important"
        >DM</span>

        <v-btn icon @click.stop="opened = !opened">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider></v-divider>
    </template>

    <template #append>

      <v-divider class="mx-4 my-2" />

      <div class="pa-2">
        <v-btn
          :to="{ name: 'donate' }"
          :disabled="$route.name === 'donate'"
          color="secondary"
          class="mb-2"
          block
        >
          <v-icon left>mdi-hand-coin-outline</v-icon>
          {{ $t('route.donate') }}
        </v-btn>

        <v-btn
          :href="retreatPdf"
          target="_blank"
          color="primary"
          class="mb-2"
          block
        >
          <v-icon left>mdi-download</v-icon>
          {{ $t('btn.retreat') }}
        </v-btn>

        <v-select
          v-model="$i18n.locale"
          :items="availableLanguages"
          style="max-width: 100%"
          prepend-inner-icon="mdi-translate"
          hide-details
          class="select-transparent"
          flat
          solo
          dense
        />
      </div>

      <v-sheet class="caption text-right text-no-wrap background">
        <div class="px-4 py-1" style="opacity: 0.5" v-text="$t('sidebar.copyright', {
          year,
        })"></div>
      </v-sheet>
    </template>

    <v-list>
      <v-list-item
        v-for="link in links"
        :key="link.key"
        :to="{ name: link.key }"
        exact
        link
      >
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('route.' + link.key) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts">
import { Vue, Component, VModel } from 'vue-property-decorator';
import { availableLanguages, retreatPdf, links } from '@/global';

@Component
export default class Sidebar extends Vue {
  @VModel({ type: Boolean, default: false }) opened!: boolean

  links = links
  availableLanguages = availableLanguages
  retreatPdf = retreatPdf
  year = new Date().getFullYear()
}
</script>
